import i18n from './i18n';
import booking from './booking';
import auth from './auth';

export default { i18n, booking, auth };
